import { render, staticRenderFns } from "./search.vue?vue&type=template&id=6b296c98&scoped=true&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=6b296c98&prod&scoped=true&lang=less&"
import style1 from "./search.vue?vue&type=style&index=1&id=6b296c98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b296c98",
  null
  
)

export default component.exports